import { useEffect, useState } from "react";
import { AppleIcon, GoogleIcon, HidePassword, OpenXLogo, ShowPassword } from "../../../assets"
import bgImage from "../../../assets/webp/SignInBGImage.webp"
import styles from "./style.module.css"
import { ButtonComponent } from "../../components/button";
import { Link, useNavigate } from "react-router-dom";
import { useResetPasswordMutation } from "../../../redux/services/authApi";


export const NewPassword = () =>
{
      const [isLoading, setIsLoading] = useState(false);
      const [errorMessage, setErrorMessage] = useState('');

      const [email, setEmail] = useState<string>('');

       const [showPassword, setShowPassword] = useState(false);
      const [new_password, setPassword] = useState('');

      const [showConfPassword, setShowConfPassword] = useState(false);
      const [confirm_password, setConfPassword] = useState('');

      const [resetPassword] = useResetPasswordMutation();

      const navigate = useNavigate();

      const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
      };

      const toggleConfPasswordVisibility = () => {
        setShowConfPassword(!showConfPassword);
      };

          useEffect(() => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            setEmail(urlParams.get('email') as string);
            console.log('Received email for verification:', urlParams.get('email'));
          }, []);

  const isValidPassword = (
  password: string,
  setErrorMessage: (msg: string) => void
): boolean => {
  if (password.length < 8) {
    setErrorMessage("• Password must be at least 8 characters long");
    return false;
  }
  if (!/[A-Z]/.test(password)) {
    setErrorMessage("• Password must contain at least one uppercase letter");
    return false;
  }
  if (!/[a-z]/.test(password)) {
    setErrorMessage("• Password must contain at least one lowercase letter");
    return false;
  }
  if (!/[0-9]/.test(password)) {
    setErrorMessage("• Password must contain at least one digit");
    return false;
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':\"\\|,.<>/?]/.test(password)) {
    setErrorMessage("• Password must contain at least one special character");
    return false;
  }

  setErrorMessage(""); // clear if valid
  return true;
};

      const ChangePassword = async () => 
      {
          if(isLoading) 
          {
            console.log("Is Processing");
            return;
          }

          setErrorMessage("");

          if(!isValidPassword(new_password, setErrorMessage))
          {
            console.log("Returned");
            return
          }
          if(!isValidPassword(confirm_password, setErrorMessage))
          {
            return
          }

          if(new_password != confirm_password)
          {
            setErrorMessage("• Confirm password does not match the new password")
            return
          }


        try
        {
           const payload = await resetPassword({ email, new_password}).unwrap();

           console.log("Changed Successfully");

           navigate('/marketPlace');

        }
      catch (err: any) {
        console.error('API error:', err);

        // RTK Query wraps errors in a standard structure
        if (err?.data?.detail) {
          setErrorMessage(`• ${err.data.detail}`);
        console.log('API error:', err);

        } else if (err?.error) {
          setErrorMessage(`• ${err.error}`);
        console.log('API error:', err);

        } else {
          setErrorMessage('• Something went wrong. Please try again.');
        }
      } 
        finally
        {
            setIsLoading(false);
        }
      }

    return (
      <div className={styles.container}>
        <img className={styles.bgImg} src={bgImage} alt="Gallery Image"></img>
        <div className={styles.entryContainer}>
          <OpenXLogo className={styles.icon} />
          <div className={styles.headerTxt}>Forgot Password?</div>
          <div className={styles.orTxt}>Create a new password for your OpenX account</div>


        <form className={styles.form}>


           <div className={styles.field}>
            <label htmlFor="password" className={styles.label}>
              New Password
            </label>
            <div className={styles.inputContainer}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className={styles.input}
                placeholder=""
                value={new_password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className={styles.passwordToggle}
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <HidePassword /> : <ShowPassword />}
              </span>
            </div>
          </div>


          <div className={styles.field}>
  <label htmlFor="confirmPassword" className={styles.label}>
    Confirm Password
  </label>
  <div className={styles.inputContainer}>
    <input
      type={showConfPassword ? "text" : "password"}
      id="confirmPassword"
      name="confirmPassword"
      className={styles.input}
      placeholder=""
      value={confirm_password}
      onChange={(e) => setConfPassword(e.target.value)}
    />
    <span
      className={styles.passwordConfToggle}
      onClick={toggleConfPasswordVisibility}
    >
      {showConfPassword ? <HidePassword /> : <ShowPassword />}
    </span>
  </div>
  <div className={styles.errMsg}>{errorMessage}</div>
</div>


         

          {/* <button type="submit" className={styles.button}>Create Account</button> */}
       
        {/* <div className={styles.fPword}></div> */}

       <ButtonComponent 
       buttonName="Change Password" 
       style={{ marginTop: 40, marginBottom: 36,
        border: 0, 
        width: '100%', 
        height: '46px' }}
        handleclick={ChangePassword}
        />
        </form>



        </div>




      </div>
    );
}